import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileAlt } from '@fortawesome/free-regular-svg-icons'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { P, match } from 'ts-pattern'
import { downloadFile } from '../../helpers/downloadFile'
import { getManual } from './services'
import { addError } from '../../redux/alerts'
import { useAppDispatch } from '../../redux/store'
import styles from './DownloadFormButton.module.css'

type State = 'not-started' | 'preparing' | 'done'

type DownloadFormButton = {
  type: string,
  year: string,
  customerNumber: string,
}

const DownloadFormButton = (props: DownloadFormButton) => {
  const { type, year, customerNumber } = props

  const [state, setState] = useState<State>('not-started')
  const dispatch = useAppDispatch()

  const handleDownload = async () => {
    try {
      setState('preparing')

      const simpleFile = await getManual(customerNumber, year, type)
      await downloadFile(simpleFile)
    } catch (err) {
      console.error(err)
      dispatch(addError('Error downloading the form'))
    } finally {
      setState('done')
    }
  }

  const disabled = !customerNumber

  return (
    <span>
      <button disabled={disabled || state === 'preparing'} onClick={handleDownload} className={styles['download-form-button']}>
        {match(state)
          .with(P.union('not-started', 'done'), () => <FontAwesomeIcon icon={faFileAlt} />)
          .with('preparing', () => <FontAwesomeIcon icon={faSpinner} spin />)
          .exhaustive()}
        <span>Download Form</span>
      </button>
      {state === 'preparing' && (
        <p className={styles['download-status-message']} role="status">
          Please wait. Your copy will download shortly...
        </p>
      )}
    </span>
  )
}

export default DownloadFormButton
